import React, {useState, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import styles from "../../css/community.module.css";
import CommunityTrending from "./CommunityTrending";
import CommunityAllThreads from "./CommunityAllThreads";
import CommunityMyQuestions from "./CommunityMyQuestions";
import CommunityMyAnswers from "./CommunityMyAnswers";
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import SearchContainer from "../../../admin/containers/SearchContainer";
import {Provider, useDispatch, useSelector} from "react-redux";
import newAdminStore from "../../../admin/store/newAdminStore";
import CommunityThreadDetailed from "./CommunityThreadDetailed";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AskEditQuestionPopUp from "./CommunityPopUps/AskEditQuestionPopUp";
import  {COMMUNITY_ACTION_TYPES} from "./communityReducer";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import SurveyHeartLogo from "../../../../public/images/surveyheart_grey.svg";
import backArrow from "../../../../public/images/arrow_back_black.svg";
import blankProfile from "../../../../public/images/avatar.png"
import CommunityMyQuestionsDetailed from "./CommunityMyQuestionsDetailed";
import CommunityMyAnswersDetailed from "./CommunityMyAnswersDetailed";
import {isMobileOnly} from "react-device-detect";
import {communityAllQuestions, detailedQuestions} from "../../../shared/utils/sash-v2-api";
import TopNavBar from "../TopNavBar";
import style from "../../css/community.module.css";
import {getColor} from "../../../shared/utils/getColor";
import * as JSONWebToken from "jsonwebtoken";
import {getSASHWebToken} from "../../../app/utils/jwt";
import MobileRedirectToApp from "../../../app/dashboard/components/MobileRedirectToApp";
import {USER_ACTION_TYPE} from "../../../app/reducers/userReducer";

const Community = () => {
    const [selectedThread, setSelectedThread] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [askPopUp, setAskPopUp] = useState(false);
    const dispatch = useDispatch();
    const [redirectToApp, setRedirectToApp] = useState(false);
    const communityNavbar = {
        Home: 'Home',
        Trending: 'Trending',
        My_Questions: 'My Questions',
        My_Answers: 'My Answers',
    }
    const [activeSection, setActiveSection] = useState(communityNavbar.Home);
    const navigate = useNavigate();
    const location = useLocation();
    const tokenData = JSONWebToken.decode(getSASHWebToken());
    const userId =  (tokenData && tokenData.userId) ? tokenData.userId : undefined;
    const allQuestionsCount = useSelector((state) => state.communityReducer.communityTotalQuestionsCount);
    const allAnswersCount = useSelector((state) => state.communityReducer.totalAnswersCount);
    const [pageIndex, setPageIndex] = useState(0);
    const QUESTIONS_PER_PAGE = 50


    if (userId) {
        dispatch({
            type: USER_ACTION_TYPE.SET_USER_ID,
            payload: userId,
        });
    }

    const handleSectionClick = (section) => {
        setActiveSection(section);
    };

    const signOutPopUp = () => {
        localStorage.setItem('communitySignOut',true)
        window.location = window.location.origin + '/app?u=0' + PAGE_HASH_LOCATION.dashboard
    }


    const fetchDetailedQuestion = (pageIndex = 0) => {
        const queryParams = new URLSearchParams(location.search);
        const threadId = queryParams.get("id");
        if (!threadId) return;

        const detailedQuestionSuccess = (response) => {
            const { answers, answers_count, result } = response;
            if (result === "SUCCESS") {
                const detailedData = { ...response, answers, answers_count };
                setSelectedThread(detailedData);
            } else {
                console.error("Unexpected response format or failure result");
            }
        };

        const detailedQuestionFailure = (error) => {
            console.error("Error fetching question details:", error);
        };

        detailedQuestions(threadId, detailedQuestionSuccess, detailedQuestionFailure, QUESTIONS_PER_PAGE, pageIndex);
    };

    useEffect(() => {
        fetchDetailedQuestion(pageIndex);
    }, [location.search,pageIndex]);

    const handlePageChange = (pageIndex) => {
        setPageIndex(pageIndex.selected);
    };

    const handleBackArrowNavigation = () => {
        if (activeSection === communityNavbar.Home) {
            window.location.href = window.location.origin;
        } else if (activeSection === communityNavbar.Trending) {
            setActiveSection(communityNavbar.Home);
        } else if (activeSection === communityNavbar.My_Questions) {
            setActiveSection(communityNavbar.Trending);
        } else if (activeSection === communityNavbar.My_Answers) {
            setActiveSection(communityNavbar.My_Questions);
        } else {
            navigate(-1);
        }
    };


    const handleTextChange = (text) => {
        setSearchTerm(text);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.type === 'click') {
            if (searchTerm) {
                triggerSearch();
            }
        }
    };


    const triggerSearch = () => {
        const handleSuccess = (response) => {
            const newData = searchTerm ? response.searchQuestions : response.all_questions;
            dispatch({
                type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
                payload: newData,
            });

            dispatch({
                type: COMMUNITY_ACTION_TYPES.SET_TOTAL_QUESTIONS_COUNT,
                payload: response.total_question_count,
            });
            dispatch({
                type: COMMUNITY_ACTION_TYPES.SET_TOTAL_ANSWER_COUNT,
                payload: response.total_answers_count,
            });


        };
        const handleFailure = (error) => {
            console.error("Error:", error);
        };
        communityAllQuestions(handleSuccess,handleFailure,20,0,  searchTerm)
    }

    const handleAddQuestion = () => {
        if (!userId) {
            localStorage.setItem("isCommunity", true);
            window.location = "/app" + PAGE_HASH_LOCATION.login;
        } else {
            setAskPopUp(true);
        }
    };

    const closePopUp = () => {
        setAskPopUp(false);
    };

    const redirectToMobileScreen = () => {
        setRedirectToApp(true)
    }


    return (
        <>
            {
                !isMobileOnly ?
                    <div style={{backgroundColor:'#F5F5F5'}}>
                        {
                            userId &&
                            <div
                                onClick={signOutPopUp}
                                className={style.communityAccount}
                                style={{backgroundColor: getColor(userId[0]),position:'absolute',right:'75px',top:'130px'}}
                            >
                                {userId[0].toUpperCase()}
                            </div>
                        }
                        <div style={{backgroundColor:'white',paddingBottom:'20px',marginTop:'-20px'}}>
                            <TopNavBar color={"black"} isCommunity={true}/>
                        </div>
                        <h1 className={`${selectedThread ? styles.communityHide : styles.communityHeading}`}>Community</h1>
                            <div className={`${selectedThread ? styles.communityHide : styles.communityBanner}`}>
                                <div style={{padding:'20px 0 5px 0'}}>
                                    <p className={styles.bannerTitle}>Welcome to our community</p>
                                    <p className={styles.desc}>Join the discussion and be part of a community that transform
                                        ideas into impactful solutions !</p>
                                    <p className={styles.communityCount}><b>{allQuestionsCount} </b> Questions  |  <b>{allAnswersCount} </b> Answers</p>
                                    <div className={`${selectedThread ? styles.communityHide : styles.searchContainer}`}>
                                        <div className={styles.searchWrapper}>
                                            <Provider store={newAdminStore}>
                                                <SearchContainer value={searchTerm} handleTextChange={handleTextChange} handleKeyDown={handleKeyDown} width={680}/>
                                            </Provider>
                                        </div>
                                        <div style={{marginTop: "-5px"}}>
                                            <ActionButtonContainer
                                                buttonText={"+ Ask Question"}
                                                handleClick={handleAddQuestion}
                                                fontSize="14px"
                                                buttonWidth="140px"
                                                height="35px"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div className={styles.community}>
                            <div className={styles.containerBody}>
                                {selectedThread ? (
                                    <CommunityThreadDetailed thread={selectedThread}
                                                             setSelectedThread={setSelectedThread}
                                                             handlePageChange={handlePageChange}/>
                                ) : (
                                    <>
                                        <div className={styles.sidebar}>
                                            <CommunityTrending onSelectThread={setSelectedThread}/>
                                            <div className={styles.contactUsBox}>
                                                <p style={{margin: "15px 5px"}}>For any queries or doubts,</p>
                                                <p style={{margin: "15px 5px"}}>Kindly reach us out.</p>
                                                <ActionButtonContainer
                                                    buttonText={"Contact Us"}
                                                    handleClick={() =>
                                                        (window.location.href =
                                                            "https://www.surveyheart.com/form/5dc50aa5b678b61dbec474a4#welcome")
                                                    }
                                                    fontSize="14px"
                                                    buttonWidth="120px"
                                                    height="35px"
                                                    fontWeight="bold"
                                                />
                                            </div>
                                        </div>

                                        <CommunityAllThreads
                                            onSelectThread={setSelectedThread}
                                            searchTerm={searchTerm}
                                        />

                                        <div className={styles.sidebar}>
                                            <CommunityMyQuestions/>
                                            <CommunityMyAnswers/>
                                        </div>
                                    </>
                                )}
                            </div>

                            {askPopUp && (
                                <PopUpContainer>
                                    <AskEditQuestionPopUp
                                        selectedThread={null}
                                        onClose={closePopUp}
                                    />
                                </PopUpContainer>
                            )}
                        </div>
                    </div>
                    :
                    <>
                        { !redirectToApp ?
                            <div style={{backgroundColor:'#F5F5F5'}}>{
                                selectedThread ?
                                    <CommunityThreadDetailed setSelectedThread={setSelectedThread}
                                                             handlePageChange={handlePageChange}
                                                             thread={selectedThread}/> :
                                    <div>
                                        <div className={styles.logoContainer}>
                                            <img className={styles.backArrow} src={backArrow} alt="Back Arrow"
                                                 onClick={handleBackArrowNavigation}/>
                                            <img className={styles.SHlogo} src={SurveyHeartLogo} alt="SurveyHeart"/>
                                            {
                                                userId ?
                                                <div
                                                    onClick={redirectToMobileScreen}
                                                    className={style.communityAccount}
                                                    style={{backgroundColor: getColor(userId[0]),position:'absolute',right:'25px'}}
                                                >
                                                    {userId[0].toUpperCase()}
                                                </div>
                                                    :
                                                <div onClick={handleAddQuestion}
                                                     style={{position:'absolute',right:'25px'}}>
                                                    <img src={blankProfile} height={30} alt={'profile'}/>
                                                </div>
                                            }

                                        </div>
                                        <div style={{marginBottom:'-35px'}} className={styles.communityBanner}>
                                            <div style={{padding:'20px 0 5px 0',marginTop:'15px'}}>
                                                <p className={styles.bannerTitle}>Welcome to our community</p>
                                                <p style={{padding:'0 10px'}} className={styles.desc}>Join the discussion and be part of a community that transform
                                                    ideas into impactful solutions !</p>
                                                <p className={styles.communityCount}><b>{allQuestionsCount} </b> Questions  |  <b>{allAnswersCount} </b> Answers</p>
                                            </div>
                                        </div>
                                        <div className={styles.communityNavbar}>
                                            <p onClick={() => handleSectionClick(communityNavbar.Home)}
                                               className={activeSection === communityNavbar.Home ? styles.active : ""}>Home
                                            </p>
                                            <p onClick={() => handleSectionClick(communityNavbar.Trending)}
                                               className={activeSection === communityNavbar.Trending ? styles.active : ""}>Trending
                                            </p>
                                            <p onClick={() => handleSectionClick(communityNavbar.My_Questions)}
                                               className={activeSection === communityNavbar.My_Questions ? styles.active : ""}>My
                                                Questions
                                            </p>
                                            <p onClick={() => handleSectionClick(communityNavbar.My_Answers)}
                                               className={activeSection === communityNavbar.My_Answers ? styles.active : ""}>My
                                                Answers
                                            </p>
                                        </div>

                                        {activeSection === communityNavbar.Home &&
                                            <CommunityAllThreads setSelectedQuestion={setSelectedThread}/>}
                                        {activeSection === communityNavbar.Trending &&
                                            <CommunityTrending setSelectedQuestion={setSelectedThread}/>}
                                        {activeSection === communityNavbar.My_Questions &&
                                            <CommunityMyQuestionsDetailed setSelectedQuestion={setSelectedThread}/>}
                                        {activeSection === communityNavbar.My_Answers &&
                                            <CommunityMyAnswersDetailed setSelectedQuestion={setSelectedThread}/>}

                                    </div>
                            }
                            </div>
                            :
                            <MobileRedirectToApp/>
                        }
                    </>
            }

        </>
    );
};

export default Community;